export default {
  sectionTitle: 'Facteurs d\'authentification',
  modalTitle: 'Voulez-vous vraiment réinitialiser vos facteurs d\'authentification ?',
  modalMessage: 'En réinitialisant vos facteurs d\'authentification, vous devrez en configurer de nouveaux lors de votre prochaine connexion à l\'Espace client.',
  noData: 'Aucun facteur d\'authentification n\'est configuré pour le moment.',
  confirmButton: 'Confirmer',
  updateButton: 'Modifier',
  resetButton: 'Réinitialiser',
};
